<template>
  <div>404 page not found</div>
</template>

<script>
export default {

}
</script>

<style>

</style>
